
import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-20 bg-gradient-to-br from-purple-900 via-purple-800 to-purple-900">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6">
          Pronta para começar sua jornada?
        </h2>
        <p className="text-xl text-white/80 mb-10">
          Aprenda com as melhores especialistas e transforme sua carreira
        </p>
        <Link
          to="/inscricao"
          className="inline-flex items-center gap-2 bg-gold-500 text-purple-900 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gold-400 transition-all hover:scale-105 shadow-lg cursor-pointer whitespace-nowrap"
        >
          Quero me inscrever
          <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}
